<template>
  <div>
    <TopBar :pagetitle="title" back-url="/textbook/license" />
    <div class="topBack">
      <div>
        <img :src="certification.license.imageFront">
      </div>
    </div>
    <div class="topImage">
      <img :src="certification.license.imageFront">
    </div>
    <div class="infoList ">
      <van-row class="item">
        <van-col span="18">
          <div class="pageTitle1 title">我的资料 /MY INFORMATION</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">国家 COUNTRY:</van-col>
            <van-col span="10">{{ getCountryText(certification.user.country) }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">姓名 NAME:</van-col>
            <van-col span="10">{{ certification.user.firstName.toUpperCase() }} {{ certification.user.lastName.toUpperCase() }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">生日 BIRTHDAY:</van-col>
            <van-col span="10">{{ formatDate(certification.user.birthday,"yyyy-MM") }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">性别 SEX:</van-col>
            <van-col span="10">{{ certification.user.sex }}</van-col>
          </van-row>
        </van-col>
        <van-col span="6" style="text-align:right"><img class="iconHead" :src="certification.user.iconImage"></van-col>
      </van-row>

      <van-row class="item">
        <van-col span="23">
          <div class="pageTitle1 title">证书信息 /CERTIFICATION</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">证书名称 NAME:</van-col>
            <van-col span="13">{{ certification.license.nameFull }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">潜水次数 TICK:</van-col>
            <van-col span="13">{{ certification.license.dives }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">编号 LICENSE ID:</van-col>
            <van-col span="13">{{ certification.license.certificationId }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="11">签发日期 DATE:</van-col>
            <van-col span="13">{{ formatDate(certification.license.dateIssue,"yyyy-MM-dd") }}</van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="item">
        <van-col span="18">
          <div class="pageTitle1 title">潜店信息 /DIVE CENTER</div>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">中心 CENTER:</van-col>
            <van-col span="10">{{ certification.license.divecenterName }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">中心编号 CENTER ID:</van-col>
            <van-col span="10">{{ certification.license.divecenterNumber }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">地区 CITY:</van-col>
            <van-col span="10">{{ certification.license.divecenterCity }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">国家 COUNTRY:</van-col>
            <van-col span="10">{{ certification.license.divecenterCountry }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">教练 INSTRUCTOR:</van-col>
            <van-col span="10">{{ certification.license.instructorName }}</van-col>
          </van-row>
          <van-row class="pagebody2 aboutStr">
            <van-col span="14">教练编号 INSTRUCTOR ID:</van-col>
            <van-col span="10">{{ certification.license.instructorNumber }}</van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-button type="info" size="large" @click="onGetMy">获得我的卡片</van-button>
    </div>
  </div>
</template>
<script>
import { Button } from 'vant'
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { initPage, getUrlKey, MyNotify, formatDate, getCountryText } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      cardId: undefined,
      code: undefined,
      title: '资质卡片',
      certification: undefined
    }
  },
  created() {
    initPage(false)
    var cardId = getUrlKey('i')
    if (cardId !== null) {
      this.cardId = cardId
    } else {
      MyNotify('error', '证书不存在', 2000)
      this.$router.replace('/textbook/license')
    }
    var code = getUrlKey('c')
    if (code !== null) {
      this.code = code
    } else {
      MyNotify('error', '证书不存在', 2000)
      this.$router.replace('/textbook/license')
    }

    request({
      url: '/user/getShareCertification',
      method: 'post',
      data: { cardId: this.cardId,
        code: this.code }
    }).then(response => {
      console.log(response)
      this.certification = response.data
      this.title = this.certification.user.firstName.toUpperCase() + '的资质卡片'
      this.shareIcon = this.certification.license.imageFront
    })
  },
  methods: {
    formatDate,
    getCountryText,
    onGetMy() {
      this.$router.replace('/home/index')
    }
  }
}
</script>

<style scoped>
.topBack{
    position:absolute;
    background-color: #000;
    width: 100%;
    height: 10em;
    text-align: center;
}
.topBack div{
    padding: 0 1em;
}
.topBack img{
    width: 100%;
    left: 5%;
    margin-top: 0.5em;
    border-radius: 1em;
}
.topImage{
    text-align: center;
    padding: 0 1em;
}

.topImage img{
    width: 100%;
    margin-top: 0.5em;
    visibility: hidden;
}
.infoList{
    margin: 1em;
    line-height: 1.2em;
}
.infoList .item{
    border-bottom: 1px solid #ccc;
    margin: 1em 0;
    padding-bottom: 1em;
}
.infoList .title{
    margin-bottom: 1em;
}
.infoList .iconHead{
    width: 90%;
}
.infoList .qrcode{
    width: 100%;
}
</style>
